<script>
import { Message } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      hideSubmit: true,
      redirectRoute: { name: 'Message List' }
    }
  },
  computed: {
    service() {
      return Message
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'First name',
          modelPath: [this, 'form', 'first_name'],
          disabled: true
        }),
        new fields.Input({
          label: 'Last name',
          modelPath: [this, 'form', 'last_name'],
          disabled: true
        }),
        new fields.Input({
          label: 'Email/Phone',
          type: 'email',
          modelPath: [this, 'form', 'email_phone'],
          disabled: true
        }),
        new fields.Input({
          label: 'Text',
          type: 'textarea',
          modelPath: [this, 'form', 'text'],
          disabled: true,
          autosize: { minRows: 1, maxRows: 10 }
        }),
        new fields.Switch({
          label: 'Terms and conditions',
          modelPath: [this, 'form', 'terms_and_conditions'],
          disabled: true
        })
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .is-disabled [class$='inner'],
::v-deep .el-select__tags-text {
  color: #303133 !important;
}

::v-deep .el-select {
  &__caret {
    display: none;
  }
}
::v-deep .el-form-item__label {
  width: 100% !important;
  margin-bottom: 0.5rem;
  text-align: left;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
